import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cashQoreService from 'src/services/cashQoreService';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import clsx from 'clsx';
import {
  Chip,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';
import PayoutDetail from './PayoutDetail';

const useStyles = makeStyles(theme => ({
  root: {},
  title: {
    marginBottom: theme.spacing(3)
  },
  group: {
    '& + &': {
      marginTop: theme.spacing(4)
    }
  },
  activity: {
    position: 'relative',
    '& + &': {
      marginTop: theme.spacing(3),
      '&:before': {
        position: 'absolute',
        content: '" "',
        height: 20,
        width: 1,
        top: -20,
        left: 20,
        backgroundColor: theme.palette.divider
      }
    }
  }
}));

function DirectPayments({ claim, className, ...rest }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [transactions, setTransactions] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [payoutInfo, setPayoutInfo] = useState(null);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const formatMoney = amount => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return formatter.format(amount);
  };

  const handleTransactionDetail = trx => async () => {
    setPayoutInfo(trx);
    setDialogOpen(true);
  };

  useEffect(() => {
    let op = async () => {
      try {
        let trans = [];
        if (claim.providerTransactions.length === 0) return;
        claim.providerTransactions.map(trx =>
          trans.push({ id: trx.cashQorePaymentsProviderTransactionInfoId })
        );

        let response = await cashQoreService.getTransactions(trans);

        setTransactions(response.providerTransactions);
      } catch (e) {
        enqueueSnackbar('Unable to retrieve transactions.', {
          variant: 'error'
        });
      }
    };
    op();
  }, []);

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <PayoutDetail
        payoutDetail={payoutInfo}
        dialogOpen={dialogOpen}
        handleDialogClose={handleDialogClose}
      />
      <Card>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Issue Date</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions?.map(trx => {
                    return (
                      <TableRow key={`trx${trx.providerTransactionInfoId}`}>
                        <TableCell>
                          {moment(trx.dateCreated).format('L')}
                        </TableCell>
                        <TableCell>{formatMoney(trx.amount)}</TableCell>

                        <TableCell>
                          <Chip
                            label={'View Transaction Detail'}
                            variant="outlined"
                            onClick={handleTransactionDetail(trx)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

DirectPayments.propTypes = {
  claim: PropTypes.object,
  className: PropTypes.string
};

export default DirectPayments;
